import type { Size } from '@glade-ai/ui';

/**
 * Icon size constants for SecondaryActions component.
 * Provides mapping between sprite icons (Tailwind rem units) and
 * Phosphor icons (pixel values).
 */
const ICON_SIZES = {
  /** Loading spinner size (matches option icons) */
  LOADING: {
    SPRITE: 4 as Size,
  },

  /** Menu option icon sizes */
  OPTION: {
    PHOSPHOR: 16,
    SPRITE: 4 as Size,
  },

  /** Trigger button icon sizes */
  TRIGGER: {
    COMPACT_PHOSPHOR: 20,
    COMPACT_SPRITE: 5 as Size,
    NORMAL_PHOSPHOR: 24,
    NORMAL_SPRITE: 6 as Size,
  },
} as const;

export default ICON_SIZES;
